import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./styles.css";
import { db } from "../../assets/firebase/firebaseconfig";
import { ref, query, orderByChild, equalTo, get } from "firebase/database";
import { Helmet } from "react-helmet-async";
import Loading from "../Loading";
const Login = ({ onLoginSuccess }) => {
  const [formData, setFormData] = useState({ username: "", password: "" });
  const [error, setError] = useState({});
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      // 1. Tìm tài khoản có username khớp trong nhánh 'users'
      const userRef = ref(db, "users");
      const userQuery = query(
        userRef,
        orderByChild("username"),
        equalTo(formData.username)
      );
      const snapshot = await get(userQuery);

      if (snapshot.exists()) {
        const userData = snapshot.val();
        // Lấy thông tin user đầu tiên tìm thấy
        const userId = Object.keys(userData)[0];
        const user = userData[userId];

        // 2. Kiểm tra mật khẩu
        if (user.password === formData.password) {
          // Lưu vào localStorage để các trang khác biết ai đang đăng nhập
          localStorage.setItem(
            "user",
            JSON.stringify({
              id: userId,
              username: user.username,
              role: user.role,
            })
          );

          window.dispatchEvent(new Event("authChange"));
          setError({});
          alert("Đăng nhập thành công!");
          if (onLoginSuccess) onLoginSuccess();

          navigate("/"); // Chuyển về trang chủ (không load lại trang)
        } else {
          setError({ ...error, password: "Mật khẩu không chính xác!" });
          setLoading();
        }
      } else {
        setError({ ...error, username: "Tên đăng nhập không tồn tại!" });
        setLoading(false);
      }
    } catch (err) {
      console.error(err);
      setError({ ...error, err: "Lỗi kết nối hệ thống!" });
      alert(error);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };
  console.log("err", error);
  if(loading) return <Loading />
  return (
    <div className="login-container">
    <Helmet><title key="login">
      Đăng Nhập
      </title></Helmet>
      <div className="login-card">
        <div className="login-header">
          <h2>Chào mừng trở lại</h2>
          <p>Vui lòng đăng nhập để tiếp tục </p>
        </div>
        {error.auth && <div className="auth-error-top">{error.auth}</div>}
        <form
          noValidate
          autoComplete="off"
          className="login-form"
          onSubmit={handleLogin}
        >
          <div className="form-group">
            <label>Tên đăng </label>
            <input
              name="username"
              type="text"
              placeholder="Nguyễn Văn A"
              onChange={(e) =>
                setFormData({ ...formData, username: e.target.value })
              }
              required
              value={formData.username}
            />
            {error.username && (
              <span className="error-text">{error.username}</span>
            )}
          </div>

          <div className="form-group">
            <div className="label-wrapper">
              <label>Mật khẩu</label>
              <Link to="/forgot-password">Quên mật khẩu?</Link>
            </div>
            <input
              name="password"
              type="password"
              placeholder="*******"
              value={formData.password}
              onChange={(e) =>
                setFormData({ ...formData, password: e.target.value })
              }
              required
            />
            {error.password && (
              <span className="error-text">{error.password}</span>
            )}
          </div>

          <button
            type="submit"
            className="btn-submit-contact"
            disabled={loading}
          >
            {loading ? "ĐANG XÁC THỰC..." : "ĐĂNG NHẬP"}
          </button>
        </form>

        <div className="login-divider">
          <span>Hoặc đăng nhập bằng</span>
        </div>

        <div className="social-login">
          <button className="social-btn google">
            <img
              src="https://cdn-icons-png.flaticon.com/512/2991/2991148.png"
              alt="Google"
            />
            Google
          </button>
          <button className="social-btn facebook">
            <img
              src="https://cdn-icons-png.flaticon.com/512/124/124010.png"
              alt="Facebook"
            />
            Facebook
          </button>
        </div>

        <p className="register-text">
          Bạn chưa có tài khoản? <Link to="/dang-ky">Đăng ký ngay</Link>
        </p>
      </div>
    </div>
  );
};

export default Login;
